import { styled } from '~/styled'

export const DialogNavigationBar = styled('div', {
  base: [
    'flex',
    'justify-between',
    'items-center',
    'border-b',
    'border-grey-300',
    'p-4'
  ]
})
